export default "__VITE_ASSET__B9Cr6a32__"